var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFold2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4872 23.5513L37.7762 17.5082C37.6699 16.6043 36.9038 15.9231 35.9937 15.9231H12.2732C11.3586 15.9231 10.5903 16.6108 10.4893 17.5197L8.19582 38.1608C8.07768 39.224 8.90995 40.1538 9.97971 40.1538H21.8846M17.3974 21.3077V13.2308C17.3974 9.51348 20.4109 6.5 24.1282 6.5V6.5C27.8455 6.5 30.859 9.51347 30.859 13.2308V21.3077M38.4872 40.6026V28.0385M38.4872 28.0385L34.4487 32.0769M38.4872 28.0385L42.5256 32.0769M29.9615 28.9359V41.5M29.9615 41.5L34 37.4615M29.9615 41.5L25.9231 37.4615",
    stroke: "#008CB7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold2);
export default __webpack_public_path__ + "static/media/fold2.461d889bccdc1376d621643cf98d4358.svg";
export { ForwardRef as ReactComponent };